<script lang="ts">
import { ETrackerCode } from '@/util/env';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'ETracker',

	props: {
		showOptOut: {
			type: Boolean,
			default: false
		}
	},


	data: () => ({
		optin: false,
	}),

	computed: {
		etrackerId() {
			return ETrackerCode;
		},
		tld() {
			return document.location.hostname;
		}
	},

	mounted() {
		if (this.showOptOut) {
			this.init();
		} else {
			this.inject();
		}
	},

	methods: {
		init() {
			const w = window as any;
			console.log('etracker init');
			if (this.etrackerId && !w._etracker) {
				//wait for tracklet loaded
				setTimeout(this.init, 500);
				return;
			}
			if (this.showOptOut) {
				this.optin = w._etracker.isTrackingEnabled();
			}
		},
		enableTracking(b: boolean) {
			if (!('_etracker' in window)) return;
			try {
				const _etracker = window._etracker as any;
				console.log('set tracking', b, this.tld);
				b ? _etracker.enableTracking(this.tld) : _etracker.disableTracking(this.tld);
			} catch (err) {
				console.warn('error during etracker enable/disable', err);
			}
		},
		inject() {
			if (!this.etrackerId) return;
			let e = document.getElementById('_etLoader');
			if (e) return;
			let script = document.createElement('script');
			script.id = '_etLoader'
			script.type = 'text/javascript'
			script.setAttribute('data-block-cookies', 'true');
			script.setAttribute('data-respect-dnt', 'true');
			script.setAttribute('data-secure-code', this.etrackerId);
			script.src = '//code.etracker.com/code/e.js';
			script.async = true;
			document.head.appendChild(script);
		}
	},
});
</script>

<template>
	<template v-if="showOptOut">
		<el-checkbox
			v-model="optin"
			@change="e => enableTracking(!!e)"
		>
			{{ $t('views.cms.trackingAllow') }}
		</el-checkbox>
	</template>
</template>
